import { render, staticRenderFns } from "./BrandSelectInput.vue?vue&type=template&id=673306e7&scoped=true"
import script from "./BrandSelectInput.vue?vue&type=script&lang=js"
export * from "./BrandSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673306e7",
  null
  
)

export default component.exports